export const OPEN_CONTACT_MODAL = 'open-contact-modal'

// Update these values periodically as new reviews come in
// These are used in schema markup and footer rating display
export const REVIEW_AVG = 5
export const TOTAL_REVIEW_COUNT = 271
